import axios from "axios";

export default {
  async addToFavorite(is_isbrannoe, projectInfoId) {
    await axios.post('/ajax/expert/add_favorit_project', null, {
      params: {
        state: !is_isbrannoe,
        projectInfoId: projectInfoId
      }
    }).catch(() => {
      alert('Ошибка');
    })
  }
}